// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.GeneralInfo.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import IconMenu from 'share/components/controls/Izenda.IconMenu';
import ActionBar from 'share/components/controls/Izenda.ActionBar';
import RoleName from './Izenda.RoleName';
import RoleType from './Izenda.RoleType';
import RoleAlert from './Izenda.RoleAlert';
import action from './Izenda.GeneralInfoAction';
import MainContentRoleSetup from './Izenda.MainContentRoleSetup';

function GeneralInfo(props: any) {
  return (
    <div>
      <div className='izenda-Wrapper-header'>
        <IconMenu />
        <RoleAlert store={props.store} />

        {!props.readOnly && <ActionBar onSave={props.onSave} onCancel={props.onCancel} />}
      </div>

      <div className='izenda-Wrapper-content'>
        <div className='u_paddingLeftRight u_fullHeight'>
          <div className='izenda-RoleInfo form-inline'>
            <RoleName store={props.store} readOnly={props.readOnly} />
            <RoleType store={props.store} readOnly={props.readOnly} />
          </div>
          <MainContentRoleSetup store={props.store} readOnly={props.readOnly} />
        </div>
      </div>
    </div>
  );
}

export default connect(action)(GeneralInfo);



// WEBPACK FOOTER //
// ./ui/modules/Settings/RoleSetup/RoleDetail/Izenda.GeneralInfo.jsx